'use strict';

var bp = require('../util/breakpoints');
var _ = require('lodash');

/**
 * Scrolls to the given element
 * @param {Object} $element - jQuery element to scroll to
 * @param {number} adjustment - adjustment to scroll position
 */
function scrollTo($element, offset) {
    if ($element.length === 0) {
        return;
    }
    $('html, body').animate({
        scrollTop: $element.offset().top - offset
    });
}

module.exports = {
    init: function () {
        var isStickyHeaderEnabled = $('input[name="isStickyHeaderEnabled"]').val() === 'true';

        var $scrollLinks = $('.js-bbw-scroll-anchor[href*=\\#]');
        var isStickyPromoBannerEnabled = $('input[name="isStickyPromoBannerEnabled"]').val() === 'true';
        var $stickyBanner = $('.js-sticky-header');
        var $promoBanner = $('.js-promo-banner');
        var headerHeight = isStickyHeaderEnabled && $stickyBanner.length > 0 ? $stickyBanner.outerHeight() : 0;
        var bannerHeight = isStickyPromoBannerEnabled && $promoBanner.length > 0 > 0 ? $promoBanner.outerHeight() : 0;
        var offset = headerHeight + bannerHeight;

        if (isStickyHeaderEnabled) {
            if ($('.js-sticky-header.is_stuck').length === 0) {
                offset *= 2;
            }

            $(window).on('scroll', _.debounce(function () {
                offset = headerHeight + bannerHeight;
                if ($('.js-sticky-header.is_stuck').length === 0) {
                    offset *= 2;
                }
            }));
        } else {
            offset = 0;
        }

        if ($scrollLinks.length > 0) {
            $scrollLinks.on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                var $target = $($this.attr('href'));

                if ($(window).width() > bp.values.small) {
                    scrollTo($target, 0);

                    return;
                }

                scrollTo($target, offset);
            });
        }
    }
};
